import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type { PslfFormExtension } from 'tio-data/data/resources/pslf-form.ext';

export interface PslfApproverDisplayEmailSignature {
  Args: {
    Positional: [PslfFormExtension];
  };
  Return: string;
}

/**
 * Localizes print-and-mail and closed-employer labels instead of showing an approver email. Resolve
 * intl through the helper because WarpDrive records have no owner.
 */
export default class PslfApproverDisplayEmail extends Helper<PslfApproverDisplayEmailSignature> {
  @service declare intl: IntlService;

  compute([form]: [PslfFormExtension]) {
    if (form.isPrintAndMail) {
      return `${this.intl.t('pslf.table.not_applicable')} - ${this.intl.t('pslf.table.print_and_mail')}`;
    }
    if (form.isPriorEmployerClosed) {
      return `${this.intl.t('pslf.table.not_applicable')} - ${this.intl.t('pslf.table.prior_employer_closed')}`;
    }
    return form.approverDisplayEmail;
  }
}
